<template>
  <div>

    <!--Banner Parallax-->
    <section class="topBanner" ref="parallaxBanner" :style="{ backgroundPositionY: parallaxOffset + 'px' }">
      <div class="bannerOverlay">
        <img class="iconBanner" src="/Resources/images/icon/reparation-moteur.png"/>
        <h1 class="bannerTitle">Réparation et entretien de pompes à eau</h1>
      </div>
    </section>

    <!-- Why Section -->
    <section>
      <transition :duration="1050" name="fade-in">
        <div id="AnimationOne" name="AnimationOne" v-if="showAnimationOne">
          <v-row class="gridpad2 d-flex justify-center" style="margin: 20px auto;">
            <v-col class="boiteWhySection">
              <div class="overBox">
                <v-col @click="navigateJoin" style="display:flex; align-items:center; justify-content:center; height: 100%; width: 100%;">
                  <h2 class="overBoxTitle">Nous contacter</h2>
                </v-col>
              </div>
              <v-row><v-col><h2 class="TitleWhySection">Intervention rapide et efficace</h2></v-col></v-row>
              <v-row><v-col><p class="textWhySection">Nous réagissons rapidement à vos besoins d'urgence pour minimiser l'interruption de vos activités. Nous offrons le service d'appel d'urgence.</p></v-col></v-row>
            </v-col>
            <v-col class="boiteWhySection">
              <div class="overBox">
                <v-col @click="navigateJoin" style="display:flex; align-items:center; justify-content:center; height: 100%; width: 100%;">
                  <h2 class="overBoxTitle">Nous contacter</h2>
                </v-col>
              </div>
              <v-row><v-col><h2 class="TitleWhySection">Techniciens qualifiés</h2></v-col></v-row>
              <v-row><v-col><p class="textWhySection">Notre équipe est composée de techniciens hautement qualifiés et expérimentés dans la gestion des systèmes de pompage et dans la réparation de ceux-ci.</p></v-col></v-row>
            </v-col>
            <v-col class="boiteWhySection">
              <div class="overBox">
                <v-col @click="navigateJoin" style="display:flex; align-items:center; justify-content:center; height: 100%; width: 100%;">
                  <h2 class="overBoxTitle">Nous contacter</h2>
                </v-col>
              </div>
              <v-row><v-col><h2 class="TitleWhySection">Satisfaction garantie</h2></v-col></v-row>
              <v-row><v-col><p class="textWhySection">Nous nous engageons à fournir un service de haute qualité qui répond à vos attentes et aux normes en vigueur.</p></v-col></v-row>
            </v-col>
          </v-row>
        </div>
      </transition>
    </section>

    <!-- Pourquoi choisir Bisson -->
    <section class="sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="9" class="txt-j">
          <div class="chosePad">
            <h2 class="pumpSectionTitle mb-2">Pourquoi opter pour une réparation Bisson Service</h2>
            <p class="choseText">Une bonne réparation de vos pompes n'est pas seulement une question de maintien de fonctionnement; c'est une stratégie essentielle pour assurer la durabilité, la sécurité de votre approvisionnement en eau potable, chauffage et évacuation des eaux usées. Voici pourquoi choisir des services de réparation de qualité est crucial :</p>
            <ul class="ulpad">
              <li><h3 class="choseliTitle">Durabilité accrue</h3><p class="choseliText"> : Des réparations bien effectuées prolongent la vie de vos pompes, ce qui signifie moins de remplacements et de coûts à long terme.</p></li>
              <li><h3 class="choseliTitle">Efficacité améliorée</h3><p class="choseliText"> : Une pompe correctement réparée fonctionne à son meilleur niveau d'efficacité, ce qui peut aider à réduire les coûts d'énergie.</p></li>
              <li><h3 class="choseliTitle">Prévention des pannes majeures</h3><p class="choseliText"> : Des interventions régulières permettent de détecter et de corriger les petits problèmes avant qu'ils ne deviennent de grandes pannes, évitant ainsi des arrêts imprévus.</p></li>
              <li><h3 class="choseliTitle">Sécurité</h3><p class="choseliText"> : Les équipements défectueux peuvent poser des risques de sécurité. Des réparations adéquates garantissent que les équipements fonctionnent en toute sécurité.</p></li>
              <li><h3 class="choseliTitle">Conformité réglementaire</h3><p class="choseliText"> : Certaines industries sont soumises à des réglementations strictes concernant la maintenance de leurs équipements. Des réparations professionnelles assurent la conformité aux normes en vigueur.</p></li>
            </ul>
          </div>
        </v-col>
      </v-row>
    </section>

    <!-- Réparation par secteur -->
    <section class="sectionPad">
      <transition :duration="1050" name="fade-in">
        <div id="AnimationTwo" name="AnimationTwo">
          <v-row class="d-flex justify-center">
            <v-col cols="12" lg="10" class="txt-j">
              <div class="mapPad">
                <h2 class="pumpSectionTitle mb-6">Réparation de pompe par secteur</h2>
                <v-row class="mt-4 d-flex justify-center">

                  <!--Agricole-->
                  <v-col class="boxSectorRepair">
                    <div style="border: 5px solid rgb(var(--primary)); height: 100%;">
                      <div><img class="sectorImg" src="/Resources/images/Services/agricole.jpg"/></div>
                      <div class="circleImg">
                        <img style="height: 100%; width: auto; object-position: center;" src="/Resources/images/Pumps/pompeIrrigation.jpg"/>
                      </div>
                      <div style="position: relative; z-index: 100; padding: 20px;">
                        <v-row><v-col><h2 class="txt-c SectorTitle">Agricole</h2></v-col></v-row>
                        <v-row><v-col>
                          <h3 class="choseliTitle">Protégez votre exploitation avec des services de réparation fiables.</h3>
                          <p class="choseliText">Les pompes et traitement d'eau jouent un rôle crucial dans l'approvisionnement en eau pour vos installations. Bisson Service propose une expertise spécifique pour réparer et maintenir les systèmes utilisés dans l'agriculture.</p>
                        </v-col></v-row>
                        <v-row><v-col>
                          <ul class="ulpadSector">
                            <li><h3 class="choseliTitle">Maintenance préventive</h3><p class="choseliText"> : Pour éviter les pannes pendant les périodes critiques.</p></li>
                            <li><h3 class="choseliTitle">Réparation rapide</h3><p class="choseliText"> : Minimiser les temps d'arrêt avec des interventions rapides et efficaces.</p></li>
                            <li><h3 class="choseliTitle">Nouvelle installation</h3><p class="choseliText"> : Vous avez un projet? Bisson Service est la solution tout incluse pour vous.</p></li>
                          </ul>
                        </v-col></v-row>
                      </div>
                    </div>
                  </v-col>

                  <!--Industrielles-->
                  <v-col class="boxSectorRepair">
                    <div style="border: 5px solid rgb(var(--primary)); height: 100%;">
                      <div><img class="sectorImg" src="/Resources/images/Services/industrial.jpg"/></div>
                      <div class="circleImg">
                        <img style="height: 100%; width: auto; object-position: center;" src="/Resources/images/Pumps/turbinePump.jpg"/>
                      </div>
                      <div style="position: relative; z-index: 100; padding: 20px;">
                        <v-row><v-col><h2 class="txt-c SectorTitle">Industrielles</h2></v-col></v-row>
                        <v-row><v-col>
                          <h3 class="choseliTitle">Maximisez l'efficacité opérationnelle avec des solutions de maintenance expertes.</h3>
                          <p class="choseliText">Les industries dépendent fortement des systèmes de pompages pour leurs processus de production. Bisson Service offre des services de réparation, de maintenance et d'installation pour maintenir vos systèmes à leur niveau optimal.</p>
                        </v-col></v-row>
                        <v-row><v-col>
                          <ul class="ulpadSector">
                            <li><h3 class="choseliTitle">Analyses et diagnostics avancés</h3><p class="choseliText"> : Pour éviter les pannes pendant les périodes critiques.</p></li>
                            <li><h3 class="choseliTitle">Réparations sur mesure</h3><p class="choseliText"> : Adaptées aux exigences spécifiques de vos équipements industriels.</p></li>
                            <li><h3 class="choseliTitle">Conseils techniques</h3><p class="choseliText"> : Notre équipe de conseillers expérimentés est là pour vous proposer de nouveaux systèmes.</p></li>
                          </ul>
                        </v-col></v-row>
                      </div>
                    </div>
                  </v-col>

                  <!--Commercial-->
                  <v-col class="boxSectorRepair">
                    <div style="border: 5px solid rgb(var(--primary)); height: 100%;">
                      <div><img class="sectorImg" src="/Resources/images/Services/commercial.jpg"/></div>
                      <div class="circleImg">
                        <img style="height: 100%; width: auto; object-position: center;" src="/Resources/images/Pumps/turbinePump.jpg"/>
                      </div>
                      <div style="position: relative; z-index: 100; padding: 20px;">
                        <v-row><v-col><h2 class="txt-c SectorTitle">Secteur Commercial et institutionnel</h2></v-col></v-row>
                        <v-row><v-col>
                          <h3 class="choseliTitle">Assurez le confort et la continuité des opérations dans votre établissement.</h3>
                          <p class="choseliText">Que ce soit pour les systèmes de chauffage, de refroidissement ou de traitement des eaux usées, une pompe défectueuse peut affecter l'ensemble de vos opérations. Bisson Service offre des réparations rapides pour éviter toute interruption.</p>
                        </v-col></v-row>
                        <v-row><v-col>
                          <ul class="ulpadSector">
                            <li><h3 class="choseliTitle">Service client réactif</h3><p class="choseliText"> : Intervention rapide pour toutes urgences.</p></li>
                            <li><h3 class="choseliTitle">Solutions durables</h3><p class="choseliText"> : Prolonger la durée de vie de vos équipements avec des réparations de qualité.</p></li>
                          </ul>
                        </v-col></v-row>
                      </div>
                    </div>
                  </v-col>

                  <!--Résidentielles-->
                  <v-col class="boxSectorRepair">
                    <div style="border: 5px solid rgb(var(--primary)); height: 100%;">
                      <div><img class="sectorImg" src="/Resources/images/Services/residential.jpg"/></div>
                      <div class="circleImg">
                        <img style="height: 100%; width: auto; object-position: center;" src="/Resources/images/Pumps/pompePiston.jpg"/>
                      </div>
                      <div style="position: relative; z-index: 100; padding: 20px;">
                        <v-row><v-col><h2 class="txt-c SectorTitle">Résidentielles</h2></v-col></v-row>
                        <v-row><v-col>
                          <h3 class="choseliTitle">Gardez votre maison confortable et fonctionnelle avec des services d'experts certifiés.</h3>
                          <p class="choseliText">Les pompes résidentielles, qu'elles soient pour votre puits ou votre système de chauffage, nécessitent une attention particulière pour fonctionner efficacement. Bisson Service offre un service de réparation à domicile.</p>
                        </v-col></v-row>
                        <v-row><v-col>
                          <ul class="ulpadSector">
                            <li><h3 class="choseliTitle">Évaluations complètes</h3><p class="choseliText"> : Vérifier l'état général et l'efficacité du système de pompage.</p></li>
                            <li><h3 class="choseliTitle">Réparations efficaces</h3><p class="choseliText"> : Résoudre les problèmes rapidement pour rétablir le confort de votre foyer.</p></li>
                          </ul>
                        </v-col></v-row>
                      </div>
                    </div>
                  </v-col>

                </v-row>
              </div>
            </v-col>
          </v-row>
        </div>
      </transition>
    </section>

    <!--Zone desservie-->
    <section id="map" class="sectionPad">
      <v-row>
        <v-col class="txt-j">
          <div class="mapPad">
            <h2 class="pumpSectionTitle mb-2">Zone Desservie</h2>
            <p>Chez Bisson Service, notre engagement est de fournir une assistance rapide et fiable en réparation de pompes dans un large rayon de 160 km autour de Drummondville. Voici un aperçu des régions que nous desservons activement :</p>
            <ul class="ulpad">
              <li><h3 class="mapliTitle">Drummondville</h3><p class="mapliText"> : Au cœur de notre activité, nous répondons promptement à tous les appels locaux.</p></li>
              <li><h3 class="mapliTitle">Saint-Hyacinthe</h3><p class="mapliText"> : Une présence forte dans cette région permet de répondre rapidement aux demandes de nos clients agricoles, résidentiels et commerciaux.</p></li>
              <li><h3 class="mapliTitle">Trois-Rivières</h3><p class="mapliText"> : Nos services sont complets pour les secteurs résidentiel, agricole, et commercial, assurant une couverture efficace pour tous vos besoins.</p></li>
              <li><h3 class="mapliTitle">Centre-du-Québec</h3><p class="mapliText"> : Une présence forte dans cette région permet de répondre rapidement aux demandes de nos clients.</p></li>
              <li><h3 class="mapliTitle">Sorel-Tracy</h3><p class="mapliText"> : Nous intervenons rapidement pour des urgences et des maintenances programmées.</p></li>
              <li><h3 class="mapliTitle">Saint-Jean-sur-Richelieu</h3><p class="mapliText"> : Notre service étendu couvre tous les besoins en réparation de pompes.</p></li>
              <li><h3 class="mapliTitle">Estrie</h3><p class="mapliText"> : Nous sommes présents dans cette région pour tous vos besoins résidentiel, agricole, commercial et industriel.</p></li>
            </ul>
          </div>
        </v-col>
        <v-col class="pa-0 d-flex align-center justify-center mapZoneVCol">
          <div class="mapImg"></div>
        </v-col>
      </v-row>
    </section>

    <!--Formulaire contact-->
    <section class="bgForm gridpadForm sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12">
          <h2 class="pumpSectionTitle mb-6">Nous contacter</h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <form ref="form">
            <v-row>
              <v-col>
                <v-row class="">
                  <v-col class="fieldMin">
                    <v-row class="padForm">
                      <p class="bold f-secondary" v-if="!error.name" style="font-size: 14px;">Nom:</p>
                      <p class="bold error" v-if="error.name" style="font-size: 14px;">Nom:</p>
                    </v-row>
                    <v-row class="padForm">
                      <v-text-field @change="error.name = false" id="name" name="name" type="text" v-model="item.name" bg-color="blue-lighten-5" clearable required/>
                      <p class="errorText" v-if="error.name" style="font-size: 14px; margin-top: -25px;">** Un nom est requis**</p>
                    </v-row>
                  </v-col>
                  <v-col class="fieldMin">
                    <v-row class="padForm"><p class="bold f-secondary" style="font-size: 14px;">Courriel</p></v-row>
                    <v-row class="padForm"><v-text-field id="Courriel" name="Courriel" type="text" v-model="item.email" bg-color="blue-lighten-5" clearable required/></v-row>
                  </v-col>
                  <v-col class="fieldMin">
                    <v-row class="padForm"><p class="bold f-secondary" style="font-size: 14px;">Adresse</p></v-row>
                    <v-row class="padForm"><v-text-field id="Ville" name="Ville" type="text" v-model="item.location" bg-color="blue-lighten-5" clearable required/></v-row>
                  </v-col>
                  <v-col class="fieldMin">
                    <v-row class="padForm">
                      <p class="bold f-secondary" v-if="!error.phone" style="font-size: 14px;">Téléphone</p>
                      <p class="bold error" v-if="error.phone" style="font-size: 14px;">Téléphone</p>
                    </v-row>
                    <v-row class="padForm">
                      <v-text-field id="Telephone" name="Telephone" type="text" label="xxx xxx-xxxx" v-model="item.phone" bg-color="blue-lighten-5" clearable required/>
                      <p class="errorText" v-if="error.phone" style="font-size: 14px; margin-top: -25px;">Un téléphone est requis **</p>
                    </v-row>
                  </v-col>
                  <v-col class="fieldFormMax">
                    <v-row class="padForm"><p class="bold f-secondary" style="font-size: 14px;">Description</p></v-row>
                    <v-row class="padForm">
                      <v-textarea clearable required no-resize id="description" name="description" v-model="item.Message" label="Description" bg-color="blue-lighten-5" rows="7" row-height="45" single-line :counter="520" maxlength="520"/>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row class="d-flex flex-lg-row flex-column">
              <v-col cols="12" lg="6" class="d-flex align-center justify-md-center justify-start">
                <p v-if="Dialog == 'error'" style="color: red; margin-left:15px;">Il y a eu un problème dans la demande, veuillez recommencer</p>
              </v-col>
              <v-col cols="12" lg="6" class="d-flex align-center justify-md-end justify-center">
                <v-btn v-if="Dialog != 'send'" @click="SendForm();" class="button" style="margin-right:15px;">
                  <span class="buttonText2" v-if="Dialog == 'notSend' || Dialog == 'error'">Envoyer</span>
                  <span class="buttonText2" v-if="Dialog == 'pending'">Veuillez patienter...</span>
                </v-btn>
                <h3 id="ReparePumpFormSent" v-if="Dialog == 'send'" class="f-primary" style="text-align: center; font-size: 2em;">La demande a été envoyée !</h3>
              </v-col>
            </v-row>
          </form>
        </v-col>
      </v-row>
    </section>

  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .sectionPad { padding: 50px 0px; }
  .gridpad2 { padding: 0px 50px; }
  .fade-in-enter-active, .fade-in-leave-active { transition: all 1s ease; }
  .fade-in-enter-from, .fade-in-leave-to { opacity: 0; transform: translateY(-104px); }
  .fade-in-enter-to, .fade-in-leave-from { opacity: 1; transform: translateY(0); }

  /*#region Banner Parallax*/
  .topBanner {
    height: 600px;
    background-image: url('../../../public/Resources/images/WaterAnalysis/banner_analysis.jpg');
    background-attachment: fixed;
    background-position: center 30%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: background-position-y;
  }
  .bannerOverlay {
    background-color: rgba(0, 0, 0, 0.45);
    padding: 40px 70px;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 700px;
  }
  .iconBanner { width: 55px; height: 55px; }
  .bannerTitle {
    color: #ffffff;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0;
  }
  /*#endregion*/

  /*#region Unified Titles*/
  .pumpSectionTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  /*#endregion*/

  /*#region Why Section*/
  .boiteWhySection {
    position: relative;
    max-width: 400px;
    padding: 20px;
    margin: 0px 20px;
    box-shadow: 0px 0px 10px 2px rgba(var(--primary), 0.4);
    border-radius: 6px;
    border-top: 4px solid rgb(var(--primary));
    background-color: #ffffff;
    transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;
    animation: slideUpFade 0.6s ease both;
  }
  .boiteWhySection:nth-child(1) { animation-delay: 0.0s; }
  .boiteWhySection:nth-child(2) { animation-delay: 0.15s; }
  .boiteWhySection:nth-child(3) { animation-delay: 0.30s; }
  @keyframes slideUpFade {
    from { opacity: 0; transform: translateY(30px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .boiteWhySection:hover {
    transform: translateY(-8px);
    box-shadow: 0px 12px 30px rgba(var(--primary), 0.35);
    border-top-color: rgb(var(--secondary));
  }
  .boiteWhySection:hover .overBox { opacity: 1; cursor: pointer; }
  .overBox {
    position: absolute; left: 0; top: 0; height: 100%; width: 100%;
    z-index: 10;
    background: linear-gradient(135deg, rgba(var(--primary), 0.85), rgba(var(--secondary), 0.85));
    opacity: 0;
    border-radius: 6px;
    transition: opacity 0.3s ease;
    display: flex; align-items: center; justify-content: center;
  }
  .overBoxTitle {
    color: #fff;
    font-weight: 700;
    font-size: 20px;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: center;
  }
  .TitleWhySection { font-size: 22px; color: rgb(var(--primary)); font-weight: 700; margin-bottom: 10px; }
  .textWhySection { text-align: justify; }
  /*#endregion*/

  /*#region Chose Section*/
  .ulpad { padding: 0px 60px; margin: 20px 0px; }
  .ulpad li { padding: 10px 0px; }
  .chosePad { margin: 30px auto; }
  .choseText { text-align: justify; margin: 20px 0px; }
  .choseliTitle { display: inline; font-size: 18px; color: rgb(var(--primary)); font-weight: 700; }
  .choseliText { display: inline; font-size: 16px; color: rgba(var(--menuColor), 0.6); }
  /*#endregion*/

  /*#region Map Zone*/
  .mapPad { margin: 30px auto; padding: 0px 50px; }
  .mapliTitle { display: inline; font-size: 18px; color: rgb(var(--primary)); font-weight: 700; }
  .mapliText { display: inline; font-size: 16px; color: rgba(var(--menuColor), 0.6); }
  .mapImg {
    height: 500px;
    width: 60%;
    background-image: url("../../../public/Resources/images/logo/map.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    transform: rotate(20deg);
    opacity: 0.4;
  }
  #map { margin: 50px 0px; }
  /*#endregion*/

  /*#region Sector Cards*/
  .boxSectorRepair {
    position: relative;
    overflow: hidden;
    display: inline-block;
    min-width: 45%; max-width: 50%;
    margin: 20px;
    padding: 0px;
    border-radius: 6px;
    transition: transform 0.35s ease, box-shadow 0.35s ease;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }
  .boxSectorRepair:hover {
    transform: translateY(-12px) scale(1.02);
    box-shadow: 0px 20px 45px rgba(0, 0, 0, 0.28);
  }
  .boxSectorRepair > div:first-child {
    border: 5px solid rgb(var(--primary));
    height: 100%;
    border-radius: 4px;
    transition: border-color 0.35s ease;
  }
  .boxSectorRepair:hover > div:first-child {
    border-color: rgb(var(--secondary));
  }
  .sectorImg {
    position: absolute; z-index: 1;
    height: 100%; width: 100%;
    top: 0; right: 0;
    object-position: center; object-fit: cover;
    opacity: 0;
    transition: opacity 0.4s ease;
  }
  .boxSectorRepair:hover .sectorImg { opacity: 0.18; }
  .SectorTitle {
    font-size: 24px; color: rgb(var(--secondary)); font-weight: 700;
    padding: 10px 0px;
    transition: color 0.3s ease;
  }
  .boxSectorRepair:hover .SectorTitle { color: rgb(var(--primary)); }
  .ulpadSector { padding: 0px 30px; }
  .circleImg {
    position: absolute; z-index: 10;
    top: 20px; left: 20px;
    width: 200px; height: 200px;
    border: 5px solid rgb(var(--secondary));
    border-radius: 50%;
    opacity: 0.2;
    overflow: hidden;
    transition: opacity 0.35s ease, transform 0.35s ease;
  }
  .boxSectorRepair:hover .circleImg {
    opacity: 0;
    transform: scale(0.8);
  }
  /*#endregion*/

  /*#region Form*/
  .bgForm { background-color: rgb(var(--tierce2)); }
  .gridpadForm { padding: 50px 200px; }
  .fieldMin { min-width: 50%; }
  .fieldFormMax { min-width: 100%; }
  .padForm { padding: 5px 10px; }
  /*#endregion*/

  @media handheld, only screen and (max-width: 600px) {
    .topBanner { height: 400px; background-attachment: scroll; }
    .bannerTitle { font-size: 22px; }
    .bannerOverlay { padding: 25px 20px; }
    .ulpad { padding: 0px 15px; }
    .boxSectorRepair { min-width: 90%; max-width: 95%; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .sectionPad { padding: 30px 0px; }
    .gridpad2 { padding: 0px 25px; }
    .boiteWhySection { min-width: 100%; margin: 20px; }
    .ulpad { padding: 0px 20px; }
    .chosePad { padding: 0px 25px; }
    .mapPad { padding: 0px 25px; }
    .boxSectorRepair { min-width: 90%; max-width: 95%; }
    .mapZoneVCol { display: none !important; }
    .gridpadForm { padding: 25px; }
    .fieldMin { min-width: 90%; max-width: 100%; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .topBanner { height: 500px; background-attachment: scroll; }
    .gridpad2 { padding: 0px 25px; }
    .gridpadForm { padding: 50px 50px; }
  }
</style>

<script>
  export default {
    name: 'repairPump',
    data: () => ({
      parallaxOffset: 0,
      select2: { title: 'Locataire / Tenant', value: '1' },
      cart: null,
      item: {
        name: null,
        email: null,
        phone: null,
        address: null,
        location: null,
        treatment: null,
        problems: null,
        Message: null
      },
      Dialog: 'notSend',
      error: { name: false, phone: false },
      key: '',
      showForm: true,
      showAnimationOne: false,
    }),
    methods: {
      handleParallax() {
        if (!this.$refs.parallaxBanner) return;
        this.parallaxOffset = Math.round(window.scrollY * 0.4);
      },
      validation: async function () {
        let valid = true;
        let errorFlag = { name: false, phone: false };
        if (this.item.name == null || this.item.name.length == 0) { valid = false; errorFlag.name = true; }
        if (this.item.phone == null || this.item.phone.length < 12) { valid = false; errorFlag.phone = true; }
        this.error = errorFlag;
        return valid;
      },
      login: async function () {
        let api = 'https://abstracxion.wx3data.com/security/login/BissonService';
        try {
          let response = await fetch(api, {
            method: 'PUT', mode: 'cors', cache: 'no-cache', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            redirect: 'follow', referrerPolicy: 'no-referrer',
            body: JSON.stringify({ LoginName: '', password: '' })
          });
          if (await response.ok && await response.status !== 204) {
            return await response.text();
          }
        } catch (error) { console.log(error); }
      },
      SendForm: async function () {
        this.Dialog = 'pending';
        let valid = await this.validation();
        if (valid == true) {
          let formData = new FormData(this.$refs.form);
          let api = 'https://abstracxion.wx3data.com/eCommerce/Forms/ContactUs/sendByEmail';
          try {
            let token = await this.login();
            let response = await fetch(api, {
              method: 'POST', mode: 'cors', cache: 'no-cache', credentials: 'same-origin',
              headers: { 'Authorization': 'Bearer ' + token },
              redirect: 'follow', referrerPolicy: 'no-referrer',
              body: formData
            });
            if (await response.ok && await response.status !== 204) {
              this.Dialog = 'send';
            } else { this.Dialog = 'error'; }
          } catch (error) { this.Dialog = 'error'; }
        } else { this.Dialog = 'error'; }
      },
      navigateJoin: async function () { this.$router.push('/contact'); },
    },
    mounted() {
      window.addEventListener('scroll', this.handleParallax);
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { this.showAnimationOne = true; }
        });
      }, { threshold: 0.1 });
      this.observer.observe(this.$el.querySelector('div'));
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleParallax);
      this.observer.disconnect();
    },
    components: {},
  }
</script>